import type { BreadcrumbItem } from './BreadcrumbTrail';

const decodeHtmlEntities = (value: string) => {
  const textarea = document.createElement('textarea');
  textarea.innerHTML = value;
  return textarea.value;
};

// Rails HTML is parsed only at this adapter; the standalone renderer receives safe text.
export const convertBreadcrumbsData = (raw: string, pathname: string): BreadcrumbItem[] => {
  if (raw?.length < 1) return [];
  if (pathname === '/admin') return [{ name: 'Dashboard', url: '/admin' }];
  const parsed = document.createElement('div');
  parsed.innerHTML = raw;
  return Array.from(parsed.querySelectorAll('li'))
    .map((item) => ({
      name: decodeHtmlEntities(item.textContent?.trim() ?? ''),
      url: item.querySelector('a')?.getAttribute('href') ?? ''
    }))
    .filter((item) => item.name.length > 0 && item.name !== 'Home');
};
